import { getDictionaryByElementProperty } from 'helper';
import { StationFullType } from 'Services/api/v2';
import { DictionaryType } from 'helper/types';

/**
 * Фильтрует станции по тексту в названиях (ищет в name, idx).
 * Если `searchText` пустой возвращает как есть.
 * @param stationsFull
 * @param searchText текст имени или idx для поисках станций
 * @returns
 */
export function filterStationsFullBySearchTextMonitoring(stationsFull: StationFullType[], searchText: string): StationFullType[] {
    if (!searchText) return stationsFull;
    return stationsFull.filter(({ station }) => (
        station.name.toUpperCase().includes(searchText.toUpperCase())
        || station.idx.toUpperCase().includes(searchText.toUpperCase())
    ));
}

/**
 * Фильтрует станции по выбранным регионам.
 * @param stationsFull
 * @param regionIds все возможные регионы, которые могут быть в станциях
 * @returns
 */
export function filterStationsFullByRegionIdsMonitoring(stationsFull: StationFullType[], regionIds: number[] | undefined): StationFullType[] {
    if (!regionIds || regionIds.length === 0) return stationsFull;
    return stationsFull.filter(({ station }) => (
        regionIds.includes(station.regionId)
    ));
}

/**
 * Фильтрует станции по выбранным типам категорий.
 * @param stationsFull
 * @param typeIds все возможные типы категорий, которые могут быть в станциях
 * @returns
 */
function filterStationsFullByTypeIdMonitoring(stationsFull: StationFullType[], typeIds: number | undefined): StationFullType[] {
    if (!typeIds) return stationsFull;
    return stationsFull.filter(({ station }) => (
        typeIds === station.vocStationTypeId
    ));
}

/**
 * Фильтруем станции по выбранным источникам.
 * Источники в stationFull также будут отфильтрованы, то есть будут только те, что в `datasourceIds`.
 * @param stationsFull
 * @param datasourceIds все возможные источники, которые могут быть в станциях
 */
export function filterStationFullByDatasourceIdsMonitoring(stationsFull: StationFullType[], datasourceIds: number[] | undefined): StationFullType[] {
    if (!datasourceIds) return stationsFull;
    return stationsFull.reduce((acc, curFull) => {
        const filteredDSIds = curFull.datasourceIds.filter((id) => datasourceIds.includes(id));
        if (filteredDSIds.length > 0) {
            acc.push({
                ...curFull,
                datasourceIds: filteredDSIds,
            });
        }
        return acc;
    }, [] as StationFullType[]);
}

// TODO: перенести в общие функции для словаря станций
export function getStationFullIdsMonitoring(stationsFull: StationFullType[] | DictionaryType<StationFullType>): number[] {
    if (Array.isArray(stationsFull)) {
        return stationsFull.reduce((acc, { station }) => {
            acc.push(station.id);
            return acc;
        }, [] as number[]);
    }
    return Object.keys(stationsFull).reduce((acc, idString) => {
        acc.push(+idString);
        return acc;
    }, [] as number[]);
}

/**
 * собираем все возможные фильтры для stationsFull для удобства использования
 * @example
 * const filtered = FilterStationFull.setValues(myStationFull).bySearchText('123').getDictionary();
 */
export const FilterStationsFullMonitoring = {
    values: [] as StationFullType[],
    setValues(stationFull: StationFullType[]) {
        this.values = stationFull;
        return this;
    },

    bySearchText(searchText: string) {
        this.values = filterStationsFullBySearchTextMonitoring(this.values, searchText);
        return this;
    },
    byRegionIds(regionIds: number[] | undefined) {
        this.values = filterStationsFullByRegionIdsMonitoring(this.values, regionIds);
        return this;
    },
    byTypeId(typeId: number | undefined) {
        this.values = filterStationsFullByTypeIdMonitoring(this.values, typeId);
        return this;
    },
    byDatasourceIds(datasourceIds: number[] | undefined) {
        this.values = filterStationFullByDatasourceIdsMonitoring(this.values, datasourceIds);
        return this;
    },

    getValues() {
        return this.values;
    },
    /** айди станции */
    getIds() {
        return getStationFullIdsMonitoring(this.values);
    },
    /** по id станции */
    getDictionary() {
        return getDictionaryByElementProperty(this.values, 'station', 'id');
    },
};
